



















































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { storeSupervisiUmum } from "@/store/modules/SupervisiUmumStore";
import SupervisiUmumSvc from "@/services/SupervisiUmumService";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import SupervisiUmumSeksiChecklist from "./SupervisiUmumSeksiChecklist.vue";
import SupervisiUmumRingkasanPanel from "./SupervisiUmumRingkasanPanel.vue";
import UnitRuangPicker, { UnitRuangOption } from "@/components/common/UnitRuangPicker.vue";

@Component({
  components: { SupervisiUmumSeksiChecklist, SupervisiUmumRingkasanPanel, UnitRuangPicker }
})
export default class SupervisiUmumForm extends Vue {
  @Prop({ default: null }) sessionData!: any;

  storeModule = storeSupervisiUmum;
  session: any = null;
  tabIndex = 0;
  saving = false;
  signing = false;
  showSignDialog = false;
  signPassword = "";

  form: any = {
    unit_id: "",
    unit_nama: "",
    unit_type: null,
    tanggal_supervisi: moment().format("YYYY-MM-DD"),
    waktu_mulai: moment().format("HH:mm"),
    waktu_selesai: "",
    kepala_unit_nama: "",
    ka_ruang_id: null,
    suhu_ruang: null,
    kelembaban: null,
    tekanan_ruang_pa: null,
    ach_rate: null,
    temuan_utama: "",
    rencana_tindak_lanjut: "",
  };

  allItems: any[] = [];

  rules = {
    required: (v: any) => !!v || "Wajib diisi",
  };

  unitTypeOptions = [
    { text: "Ranap (Bangsal)", value: "ranap" },
    { text: "ICU", value: "icu" },
    { text: "NICU", value: "nicu" },
    { text: "PICU", value: "picu" },
    { text: "IGD", value: "igd" },
    { text: "IBS / Kamar Operasi (OK)", value: "ok" },
    { text: "VK / Kamar Bersalin", value: "vk" },
    { text: "Hemodialisa", value: "hd" },
    { text: "Poliklinik", value: "poli" },
    { text: "Isolasi", value: "isolasi" },
    { text: "HCU / Intermediate", value: "hcu" },
    { text: "Perinatologi", value: "perinatologi" },
  ];

  allSeksiList = [
    { seksi: "kebersihan_tangan", label: "I. Kebersihan Tangan (Hand Hygiene)", shortLabel: "I. HH" },
    { seksi: "apd", label: "II. Alat Pelindung Diri (APD)", shortLabel: "II. APD" },
    { seksi: "limbah", label: "III. Pengelolaan Limbah", shortLabel: "III. Limbah" },
    { seksi: "lingkungan", label: "IV. Pengendalian Lingkungan", shortLabel: "IV. Lingk." },
    { seksi: "linen", label: "V. Pengelolaan Linen", shortLabel: "V. Linen" },
    { seksi: "alat_pasien", label: "VI. Pengelolaan Peralatan Perawatan Pasien", shortLabel: "VI. Alat" },
    { seksi: "kesehatan_karyawan", label: "VII. Perlindungan Petugas", shortLabel: "VII. Kes." },
    { seksi: "penyuntikan_aman", label: "VIII. Penyuntikan yang Aman", shortLabel: "VIII. Suntik" },
    { seksi: "penempatan_pasien", label: "IX. Penempatan Pasien", shortLabel: "IX. Pasien" },
    { seksi: "etika_batuk", label: "X. Etika Batuk", shortLabel: "X. Batuk" },
    { seksi: "lumbal_pungsi", label: "XI. Lumbal Pungsi", shortLabel: "XI. LP" },
    { seksi: "kewaspadaan_transmisi", label: "XII. Kewaspadaan Transmisi", shortLabel: "XII. Transmisi" },
  ];

  get isIsolasi() {
    return this.form.unit_type === "isolasi";
  }

  get activeSeksiList() {
    // Filter seksi that have applicable items
    return this.allSeksiList.filter(s => {
      const items = this.getItemsBySeksi(s.seksi);
      return items.length > 0;
    });
  }

  async mounted() {
    // Load definitions (filtered by unit_type if set)
    const params: any = { aktif: true };
    if (this.sessionData?.unit_type) {
      params.unit_type = this.sessionData.unit_type;
    }
    await this.storeModule.loadDefinitions(params);
    this.initItems();
    await this.$nextTick();
    this.tabIndex = 0;

    // If editing
    if (this.sessionData?.id) {
      await this.storeModule.loadDetail(this.sessionData.id);
      this.session = this.storeModule.currentSession;
      this.populateForm();
    }
  }

  initItems() {
    const defs = this.storeModule.definitions || [];
    this.allItems = defs.map((def: any) => ({
      definition_id: def.id,
      kode_item: def.kode_item,
      seksi: def.seksi,
      urutan: def.urutan,
      komponen_supervisi: def.komponen_supervisi,
      tipe_jawaban: def.tipe_jawaban,
      nilai_target_min: def.nilai_target_min,
      nilai_target_max: def.nilai_target_max,
      kritikal: def.kritikal,
      applicable_unit_type: def.applicable_unit_type,
      display_no: this.getDisplayNo(def),
      // Answer fields
      hasil: null,
      jumlah_observasi: null,
      jumlah_compliant: null,
      masalah: "",
      rekomendasi: "",
      foto_bukti: [],
    }));
  }

  getDisplayNo(def: any) {
    const kode = def.kode_item || "";
    const parts = kode.split("-");
    return parts[parts.length - 1] || "";
  }

  populateForm() {
    if (!this.session) return;
    const s = this.session;
    this.form = {
      unit_id: s.unit_id || "",
      unit_nama: s.unit_nama || "",
      unit_type: s.unit_type || null,
      tanggal_supervisi: s.tanggal_supervisi ? moment(s.tanggal_supervisi).format("YYYY-MM-DD") : "",
      waktu_mulai: s.waktu_mulai || "",
      waktu_selesai: s.waktu_selesai || "",
      kepala_unit_nama: s.kepala_unit_nama || "",
      ka_ruang_id: s.ka_ruang_id,
      suhu_ruang: s.suhu_ruang,
      kelembaban: s.kelembaban,
      tekanan_ruang_pa: s.tekanan_ruang_pa,
      ach_rate: s.ach_rate,
      temuan_utama: s.temuan_utama || "",
      rencana_tindak_lanjut: s.rencana_tindak_lanjut || "",
    };

    // Populate items from session items
    if (s.items && s.items.length > 0) {
      for (const savedItem of s.items) {
        const local = this.allItems.find((i: any) => i.definition_id === savedItem.definition_id);
        if (local) {
          local.hasil = savedItem.hasil;
          local.jumlah_observasi = savedItem.jumlah_observasi;
          local.jumlah_compliant = savedItem.jumlah_compliant;
          local.masalah = savedItem.masalah || "";
          local.rekomendasi = savedItem.rekomendasi || "";
          local.foto_bukti = savedItem.foto_bukti || [];
        }
      }
    }
  }

  /**
   * Filter picker unit mengikuti Tipe Unit terpilih (feedback "unit ruang
   * masih tercampur"): poli → ralan; tanpa tipe → semua (grouped);
   * tipe ruang rawat/tindakan lain → ranap + penunjang (+ IGD).
   */
  get unitPickerKategori(): string[] {
    if (!this.form.unit_type) return [];
    if (this.form.unit_type === "poli") return ["ralan"];
    return ["ranap", "penunjang"];
  }

  get unitPickerIncludeIgd(): boolean {
    return !!this.form.unit_type && this.form.unit_type !== "poli";
  }

  onUnitPicked(unit: UnitRuangOption | null) {
    this.form.unit_nama = unit ? unit.nama : "";
  }

  async onUnitTypeChange() {
    // Reload definitions filtered by unit_type
    const params: any = { aktif: true };
    if (this.form.unit_type) {
      params.unit_type = this.form.unit_type;
    }
    await this.storeModule.loadDefinitions(params);
    this.initItems();
    await this.$nextTick();
    this.tabIndex = 0;
  }

  getItemsBySeksi(seksi: string) {
    return this.allItems
      .filter((i: any) => i.seksi === seksi)
      .sort((a: any, b: any) => a.urutan - b.urutan);
  }

  /** Seksi punya temuan (naratif) — penanda oranye di tab. */
  hasSeksiTemuan(seksi: string) {
    return this.getItemsBySeksi(seksi).some(
      (i: any) => i.masalah && String(i.masalah).trim() !== ""
    );
  }

  onItemsChange() {
    // Items are reactive
  }

  onFormUpdate(updatedForm: any) {
    Object.assign(this.form, updatedForm);
  }

  buildPayload() {
    return {
      ...this.form,
      items: this.allItems.map((i: any) => ({
        definition_id: i.definition_id,
        hasil: i.hasil,
        jumlah_observasi: i.tipe_jawaban === "observasi" ? i.jumlah_observasi : null,
        jumlah_compliant: i.tipe_jawaban === "observasi" ? i.jumlah_compliant : null,
        masalah: i.masalah || null,
        rekomendasi: i.rekomendasi || null,
        foto_bukti: i.foto_bukti?.length > 0 ? i.foto_bukti : null,
      })),
    };
  }

  async simpanDraft() {
    if (!(this.$refs.formHeader as any).validate()) return;
    this.saving = true;
    try {
      const payload = this.buildPayload();
      let resp;
      if (this.session?.id) {
        resp = await SupervisiUmumSvc.update(this.session.id, payload);
      } else {
        resp = await SupervisiUmumSvc.create(payload);
      }
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Draft berhasil disimpan");
        this.session = resp.data.data;
        this.$emit("saved");
      }
    } catch {
      // handled by ErrorAlert
    }
    this.saving = false;
  }

  async submitAndSign() {
    if (!(this.$refs.formHeader as any).validate()) return;

    // Naratif: tidak ada kewajiban ya/tidak per item — temuan/rekomendasi opsional.
    // First submit data
    this.saving = true;
    try {
      const payload = this.buildPayload();
      let resp;
      if (this.session?.id) {
        resp = await SupervisiUmumSvc.submit(this.session.id, payload);
      } else {
        resp = await SupervisiUmumSvc.create(payload);
        if (resp?.data?.status == "1") {
          this.session = resp.data.data;
          resp = await SupervisiUmumSvc.submit(this.session.id, payload);
        }
      }
      if (resp?.data?.status == "1") {
        this.session = resp.data.data;
        this.showSignDialog = true;
      }
    } catch {
      // handled by ErrorAlert
    }
    this.saving = false;
  }

  async doSign() {
    if (!this.signPassword) {
      appModule.NoticeDelay("Password wajib diisi");
      return;
    }
    this.signing = true;
    try {
      const resp = await SupervisiUmumSvc.signSupervisor(this.session.id, {
        password: this.signPassword,
      });
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil menandatangani. Menunggu acknowledge Ka. Ruang.");
        this.showSignDialog = false;
        this.signPassword = "";
        this.$emit("saved");
        this.$emit("back");
      }
    } catch {
      // handled by ErrorAlert
    }
    this.signing = false;
  }
}
